export default "__VITE_ASSET__D8XKdIF8__"